import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useLunaSettingsFetch = () => {
  const response = useQuery({
    queryKey: ['lunaSettings'],
    queryFn: () => api.luna.fetchSettings(),
    enabled: false, // Запрос выполняется только по требованию
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки Luna',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
